import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Multiple = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Multiple" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M19 0C21.7614 0 24 2.23858 24 5V11C24 13.4491 22.2388 15.4844 19.9141 15.9141C19.5392 17.9423 17.9423 19.5392 15.9141 19.9141C15.4844 22.2388 13.4491 24 11 24H5C2.23858 24 0 21.7614 0 19V13C0 10.5512 1.76065 8.51495 4.08496 8.08496C4.46005 6.05739 6.05739 4.46005 8.08496 4.08496C8.51495 1.76065 10.5512 0 13 0H19ZM5 10C3.34315 10 2 11.3431 2 13V19C2 20.6569 3.34315 22 5 22H11C12.6569 22 14 20.6569 14 19V13C14 11.3431 12.6569 10 11 10H5ZM9 6C7.69415 6 6.58594 6.83532 6.17383 8H11C13.7614 8 16 10.2386 16 13V17.8252C17.1645 17.413 18 16.3057 18 15V9C18 7.34315 16.6569 6 15 6H9ZM13 2C11.6941 2 10.5859 2.83532 10.1738 4H15C17.7614 4 20 6.23858 20 9V13.8252C21.1645 13.413 22 12.3057 22 11V5C22 3.34315 20.6569 2 19 2H13Z" fill="#000" />
  </StyledIcon>
));

Multiple.displayName = 'Multiple';

export { Multiple };
